export const TemplateCategoryEnum = {
  ALIMTALK: 'ALIMTALK',
  FRIENDTALK: 'FRIENDTALK',
  BRANDMESSAGE: 'BRANDMESSAGE',
  SMS: 'SMS',
};

export const categoriesList = [
  {
    value: TemplateCategoryEnum.ALIMTALK,
    label: TemplateCategoryEnum.ALIMTALK,
  },
  {
    value: TemplateCategoryEnum.BRANDMESSAGE,
    label: 'BRAND MESSAGE (FRIENDTALK)',
  },
  {
    value: TemplateCategoryEnum.SMS,
    label: 'SMS/LMS/MMS',
  },
];
